// extracted by mini-css-extract-plugin
export default {"container":"components-login-email-verification-module__container","form":"components-login-email-verification-module__form"};